module.exports = __webpack_public_path__ + "static/lightning-picklist-2fd435957f74f31f576ec03e702d53dc.png";